type PreviousWindowQueryGateInput = {
  isAuthenticated: boolean;
  showDelta: boolean;
  comparisonActivated: boolean;
  hasCurrentWindowData: boolean;
};

type JobsPreviousWindowComparisonInput = {
  showDelta: boolean;
  hasPreviousJobsData: boolean;
  hasPreviousRunsData: boolean;
};

type JobsSecondaryQueryGateInput = {
  currentJobsSettled: boolean;
  currentRunsSettled: boolean;
  isAuthenticated: boolean;
};

export const shouldLoadJobsPreviousWindowQuery = ({
  isAuthenticated,
  showDelta,
  comparisonActivated,
  hasCurrentWindowData,
}: PreviousWindowQueryGateInput): boolean =>
  isAuthenticated && showDelta && comparisonActivated && hasCurrentWindowData;

export const shouldShowJobsPreviousWindowComparison = ({
  showDelta,
  hasPreviousJobsData,
  hasPreviousRunsData,
}: JobsPreviousWindowComparisonInput): boolean =>
  showDelta && hasPreviousJobsData && hasPreviousRunsData;

export const shouldLoadJobsSecondaryQueries = ({
  currentJobsSettled,
  currentRunsSettled,
  isAuthenticated,
}: JobsSecondaryQueryGateInput): boolean =>
  isAuthenticated && currentJobsSettled && currentRunsSettled;
